import EmblaCarousel from 'embla-carousel';
import {clickEvent, documentLoadEvent} from "../../../webpack/modules/events";
import {showReviewImageZoomPopup} from "../../../webpack/modules-optimized/popup-review-image-zoom";
import {onVisible} from "../../../scripts/Tools/visible-element-observer";
import {initProductImageSlider} from "../../../webpack/modules-optimized/product-list";

clickEvent('#product-page .review-image-zoom-popup', true, function (element, event) {
    let position = element.dataset.position;
    showReviewImageZoomPopup(Number(position));
});

documentLoadEvent(function() {
    onVisible(document.querySelectorAll('.review-images-carousel'), function(slider) {
        initReviewImagesCarousel(slider);
    }, 0.7);
});

function initReviewImagesCarousel(container) {
    const slider = container.querySelector('.embla-carousel');
    if (!slider) {
        return;
    }

    const prevButton = container.querySelector('.embla-prev-button');
    const nextButton = container.querySelector('.embla-next-button');

    const autoplayEnabled = String(container.dataset.autoplay) !== 'false';
    const autoplaySpeed = parseInt(container.dataset.autoplaySpeed, 10) || 5000;

    const embla = EmblaCarousel(slider, {
        loop: false,
        align: 'start',
        slidesToScroll: 'auto',
        containScroll: 'trimSnaps'
    });

    if (prevButton) {
        prevButton.addEventListener('click', function () {
            embla.scrollPrev();
            restartAutoplay();
        });
    }
    if (nextButton) {
        nextButton.addEventListener('click', function () {
            embla.scrollNext();
            restartAutoplay();
        });
    }

    let autoplayTimer = null;

    const startAutoplay = function () {
        if (!autoplayEnabled || autoplayTimer) {
            return;
        }
        autoplayTimer = setInterval(function () {
            embla.scrollNext();
        }, autoplaySpeed);
    };

    const stopAutoplay = function () {
        if (autoplayTimer) {
            clearInterval(autoplayTimer);
            autoplayTimer = null;
        }
    };

    const restartAutoplay = function () {
        if (!autoplayEnabled) {
            return;
        }
        stopAutoplay();
        startAutoplay();
    };

    if (autoplayEnabled) {
        container.addEventListener('mouseenter', stopAutoplay);
        container.addEventListener('mouseleave', startAutoplay);

        if ('IntersectionObserver' in window) {
            const observer = new IntersectionObserver(function (entries) {
                entries.forEach(function (entry) {
                    if (entry.isIntersecting) {
                        startAutoplay();
                    } else {
                        stopAutoplay();
                    }
                });
            }, { threshold: 0.1 });
            observer.observe(container);
        } else {
            startAutoplay();
        }
    }

    container.classList.add('embla-initialized');
    embla.reInit();
}
